const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const headers = () => {
  const h = { 'Content-Type': 'application/json' };
  const t = localStorage.getItem('tennisbuzz_token');
  if (t) h['Authorization'] = `Bearer ${t}`;
  return h;
};

const req = async (url, opts = {}) => {
  const res = await fetch(`${BASE}${url}`, { headers: headers(), ...opts });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Request failed');
  return data;
};

export const tpAPI = {
  listPlayers:  (tId)           => req(`/tournament-players/${tId}`),
  createPlayer: (tId, body)     => req(`/tournament-players/${tId}`,              { method: 'POST', body: JSON.stringify(body) }),
  updatePlayer: (pId, body)     => req(`/tournament-players/player/${pId}`,       { method: 'PUT',  body: JSON.stringify(body) }),
  deletePlayer: (pId)           => req(`/tournament-players/player/${pId}`,       { method: 'DELETE' }),
  bulkSetup:    (tId, body)     => req(`/tournament-players/${tId}/bulk-setup`,   { method: 'POST', body: JSON.stringify(body) }),

  // groups
  createGroup:  (gsId, body)    => req(`/group-stage/${gsId}/create-group`,        { method: 'POST',   body: JSON.stringify(body) }),
  renameGroup:  (gId, name)     => req(`/group-stage/group/${gId}/rename`,          { method: 'PATCH',  body: JSON.stringify({ name }) }),
  deleteGroup:  (gId)           => req(`/group-stage/group/${gId}`,                 { method: 'DELETE' }),

  // teams
  createTeam:   (gId, body)     => req(`/group-team/group/${gId}/create-team`,   { method: 'POST', body: JSON.stringify(body) }),
  updateTeam:   (tId, body)     => req(`/group-team/team/${tId}`,                { method: 'PUT',  body: JSON.stringify(body) }),
  deleteTeam:   (tId)           => req(`/group-team/team/${tId}`,                { method: 'DELETE' }),
  getTeams:     (gId)           => req(`/group-team/group/${gId}/teams`),

  // stage data
  getStageForTournament: (tId)  => req(`/group-stage/tournament/${tId}/details`),
  getTournament:         (tId)  => req(`/tournaments/${tId}`),

  // qualify / eliminate teams
  qualifyTeams:  (gId, count) => req(`/group-team/group/${gId}/qualify-teams`,   { method: 'POST', body: JSON.stringify({ qualifierCount: count }) }),
  eliminateTeams:(gId, ids)   => req(`/group-team/group/${gId}/eliminate-teams`, { method: 'POST', body: JSON.stringify({ teamIds: ids }) }),
};
